import UserIcon from '@/shared/assets/icons/user.svg?react'
import { useActiveUser } from '@/shared/hooks'
import { VerificationStatus } from '../../VerificationStatus/VerificationStatus'

export const CardInfo = () => {
  const { userData } = useActiveUser()

  return (
    <div className="flex sm:flex-row flex-col sm:justify-between items-start sm:items-center gap-6 w-full">
      <div className="flex justify-start gap-4">
        <div className="relative bg-light-purple dark:bg-dark-purple rounded-full w-[52px] h-[52px]">
          <div className="top-[50%] left-[50%] absolute text-primary dark:text-primary-dark -translate-x-1/2 -translate-y-1/2 transform">
            <UserIcon />
          </div>
        </div>
        <div className="flex flex-col gap-1">
          <span className="font-medium text-text-main dark:text-white">
            {userData?.email ?? ''}
          </span>
          <span className="text-text-secondary text-sm">{userData?.teamName ?? 'Нет команды'}</span>
        </div>
      </div>
      <VerificationStatus status={userData?.isVerified ? 'done' : 'failed'} />
    </div>
  )
}
